import Link from 'next/link'
import s from './styles.module.css'

const LastPosts = ({ className, latestAuthorPosts, title }) => {
  return (
    <div className={className}>
      <span>{title}</span>
      <ul>
        {latestAuthorPosts.map(post => (
          <li key={post.sys.id} className={s.linkRow}>
            <Link href={`/blog/${post.fields.slug}`} className={s.link}>
              {post.fields.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default LastPosts
